import { render, staticRenderFns } from "./uploadImages.vue?vue&type=template&id=20272fae&scoped=true"
import script from "./uploadImages.vue?vue&type=script&lang=js"
export * from "./uploadImages.vue?vue&type=script&lang=js"
import style0 from "./uploadImages.vue?vue&type=style&index=0&id=20272fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20272fae",
  null
  
)

export default component.exports